var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "top-start",
            title: _vm.$t("SeaExport.Details"),
            width: "500",
            trigger: "hover",
            content: _vm.content
          }
        },
        [
          _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
            _vm._v(_vm._s(_vm.shortContent))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }